import axios from "helpers/axiosInstance";
import { AxiosRequestConfig, AxiosResponse } from "axios";

// Generic GET request
export const getRequest = async <T>(
  url: string,
  config?: { signal?: AbortSignal },
): Promise<T> => {
  const response: AxiosResponse<T> = await axios.get(url, config);
  return response.data;
};

// Generic POST request
export const postRequest = async <T, R>(
  url: string,
  data: R,
  config?: AxiosRequestConfig,
): Promise<T> => {
  const response: AxiosResponse<T> = await axios.post(url, data, config);
  return response.data;
};
